import { useState } from "react"
import { FormI } from "./types"
import { ReactMultiSelectOptionT } from "../shared/input/react-select/multiSelect"
import { ActionMeta, MultiValue } from "react-select"
import { cloneDeep } from "lodash"

export const useOrganizationMembershipAccessForm = (initialForm: FormI) => {
    const [form, setForm] = useState<FormI>(() => cloneDeep(initialForm))

    const handleManagedAccessChange = (value: boolean) => {
        setForm((prev) => ({
            ...prev,
            fullAccess: value,
        }))
    }

    const handleWellPermissionsChange = (
        _: MultiValue<ReactMultiSelectOptionT>,
        actionMeta: ActionMeta<ReactMultiSelectOptionT>
    ) => {
        switch (actionMeta.action) {
            case "clear":
                setForm((prev) => ({
                    ...prev,
                    wellPermissions: prev.wellPermissions.map((well) => ({
                        ...well,
                        isSelected: false,
                    })),
                }))
                break
            case "deselect-option": {
                const removedWell = actionMeta.option
                if (!removedWell) {
                    return
                }

                const updatedWell = { ...removedWell, isSelected: false }

                setForm((prev) => ({
                    ...prev,
                    wellPermissions: prev.wellPermissions.map((well) =>
                        well.value === updatedWell.value ? updatedWell : well
                    ),
                }))
                break
            }
            case "select-option": {
                const selectedWell = actionMeta.option
                if (!selectedWell) {
                    return
                }

                const updatedWell = { ...selectedWell, isSelected: true }

                setForm((prev) => ({
                    ...prev,
                    wellPermissions: prev.wellPermissions.map((well) =>
                        well.value === updatedWell.value ? updatedWell : well
                    ),
                }))
                break
            }
        }
    }

    const handleSelectAllWells = (updatedSelect: boolean) => {
        setForm((prev) => ({
            ...prev,
            wellPermissions: prev.wellPermissions.map((well) => ({
                ...well,
                isSelected: updatedSelect,
            })),
        }))
    }

    return {
        form,
        handleManagedAccessChange,
        handleWellPermissionsChange,
        handleSelectAllWells,
    }
}
